import React from 'react';

function BarTwitterIcon(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      {...props}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M0 0H30V30H0z"
              transform="translate(-1465 -605) translate(1465 605)"
            />
            <path
              fill="#3DB2FF"
              fillRule="nonzero"
              d="M24 9.682c-.662.286-1.374.478-2.121.565.762-.444 1.348-1.147 1.624-1.985-.714.411-1.504.71-2.345.87C20.484 8.437 19.524 8 18.462 8c-2.04 0-3.693 1.607-3.693 3.587 0 .282.032.555.096.818-3.07-.15-5.79-1.578-7.612-3.749-.318.53-.5 1.147-.5 1.804 0 1.244.652 2.343 1.642 2.986-.605-.018-1.174-.18-1.672-.45v.046c0 1.739 1.273 3.188 2.962 3.518-.31.082-.636.126-.973.126-.238 0-.47-.022-.694-.064.47 1.425 1.833 2.462 3.45 2.491-1.265.963-2.857 1.536-4.588 1.536-.297 0-.592-.017-.88-.05 1.633 1.018 3.575 1.612 5.66 1.612 6.793 0 10.508-5.467 10.508-10.208 0-.155-.004-.31-.011-.464.722-.506 1.348-1.137 1.843-1.857z"
              transform="translate(-1465 -605) translate(1465 605)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default BarTwitterIcon;
